import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffPurchaseRemits = () => import('./staff/purchaseRemits')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'PurchaseRemitsStaffDashboard',
  purchaseRemits: 'PurchaseStaffPurchaseRemits',
}

const router =
  [
    {
      path: '/st/purchase-remits',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Remitos de compras',
          }          
        },   
        {
          path: 'remits',
          name: VIEWS.purchaseRemits,
          component: ViewStaffPurchaseRemits,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de remitos de compras',
          }          
        },             
      ]
    },

    {
      path: '/cu/purchase-remits',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/purchase-remits',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
